export default {
  namespaced: true,
  state: () => ({
    checkoutDraft: { goods: [], address: null },
  }),
  mutations: {
    setCheckoutDraft(state, { goods, address }) {
      state.checkoutDraft = { goods, address }
    },
    clearCheckoutDraft(state) {
      state.checkoutDraft = { goods: [], address: null }
    },
  },
}
